import {
  Accordion,
  AccordionItem,
  Container,
  Grid,
  Heading,
} from '@joinrepublic/dls-ui-kit';

import { colors, containerSize } from '../../config/styles';
import { MotionBox } from '../motion-box/motion-box';
import { MotionBoxGroup } from '../motion-box-group/motion-box-group';
import { SERVICES } from './data';
import { ServiceSection } from './service-section';

export const Services = () => {
  return (
    <Container
      as="section"
      id="services"
      maxW={containerSize}
      py={{ base: '14', sm: '20' }}
    >
      <MotionBoxGroup viewportMargin="-100px">
        <Grid
          templateColumns={{ base: '1fr', sm: 'repeat(2, 1fr)' }}
          gap={{ base: '6', sm: '0' }}
        >
          <MotionBox as="header">
            <Heading
              as="h2"
              size="title-md"
              mt="0"
              color={colors.darkNavyTypography}
            >
              Services
            </Heading>
          </MotionBox>

          <MotionBox>
            <Accordion
              variant="group"
              allowToggle
              borderTop="1px solid"
              borderColor="blackAlpha.300"
            >
              {SERVICES.map((service) => (
                <AccordionItem
                  key={service.name}
                  p="0"
                  _last={{
                    borderBottom: '1px solid',
                    borderColor: 'blackAlpha.300',
                  }}
                >
                  {({ isExpanded }: { isExpanded: boolean }) => (
                    <ServiceSection service={service} isExpanded={isExpanded} />
                  )}
                </AccordionItem>
              ))}
            </Accordion>
          </MotionBox>
        </Grid>
      </MotionBoxGroup>
    </Container>
  );
};
